import * as React from 'react';
import { Helmet } from 'react-helmet-async';

// 다국어
import { useTranslation } from 'react-i18next';

// @mui
import { styled } from '@mui/material/styles';
import { Box, CssBaseline, Button } from '@mui/material';

import MainNoticeTab from '../../components/NoticeComponents/MainNoticeTab';
import TopArea from './TopArea';

// ----------------------------------------------------------------------

const BackgroundDiv2 = styled('div')(() => ({
  padding: '80px 10%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  zIndex: 1,
  gap: '80px',
  backgroundColor: '#fff',
}));

const StyleFlex = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: '#fff',
  padding: theme.spacing(7),
  borderRadius: '30px',
  height: '480px',
  boxShadow: theme.customShadows.card,
  textAlign: 'Left',
  '& h4': {
    fontWeight: 500,
    fontSize: '1.2em',
  },
}));

const BottomBanner = styled('div')(({ theme }) => ({
  margin: '0 10%',
  display: 'flex',
  justifyContent: 'space-between',
  color: '#fff',
  flexDirection: 'row',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
  padding: theme.spacing(10, 7),
  borderRadius: '30px',
  flex: 1,
  boxShadow: theme.customShadows.card,
  textAlign: 'Left',
  alignItems: 'center',
}));

const MainBanner = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: '20px',
  borderRadius: '20px',
  backgroundPosition: 'right 20px bottom 20px',
  boxShadow: theme.customShadows.card,
  width: '20%',
  height: '220px',
  '& h4': {
    fontWeight: 'bold',
    marginBottom: '10px',
  },
}));

const BannerButton = styled(Button)({
  padding: '1rem 3rem',
  color: '#fff',
  fontSize: '1.2rem',
  fontWeight: 500,
  backgroundColor: '#111',
  borderRadius: '30px',
});

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  // 다국어
  const { t } = useTranslation(['page']);
  const { t: tImg } = useTranslation(['img']);
  return (
    <>
      <CssBaseline />
      <Helmet>
        <title> Home | Raindrop </title>
      </Helmet>
      <TopArea
        easyText={t('편리한')}
        dentalText={t('치과기공소 관리')}
        helpRaindropText={t('레인드롭이 도와드려요')}
        freeText={t('무료체험하기')}
        imgSrc={tImg('main_img_2')}
      />
      <BackgroundDiv2>
        <StyleFlex style={{ background: '#E0EDFF', flex: 1, flexDirection: 'column', alignItems: 'stretch' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h2>{t('레인드롭 이용안내')}</h2>
            <h4 style={{ marginTop: '20px' }}>
              {t('설치부터 접수·통계까지')} {t('편리하게 진행해보세요.')}
            </h4>
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', alignItems: 'flex-end', flex: 1 }}>
            <MainBanner
              style={{
                background: `url(/images/main/main_banner_01.png) #FFFFFF no-repeat`,
                backgroundPosition: 'right 20px bottom 20px',
              }}
            >
              <div>
                <h4>접수 관리</h4>
                <p>
                  매일 매일 간편하게
                  <br />
                  오늘 한 일 오늘 등록!
                </p>
              </div>
            </MainBanner>
            <MainBanner
              style={{
                background: `url(/images/main/main_banner_02.png) #FFFFFF no-repeat`,
                backgroundPosition: 'right 20px bottom 20px',
              }}
            >
              <div>
                <h4>회계 관리</h4>
                <p>
                  초보자도 쉽게 쉽게
                  <br />
                  복잡한 청구서는 그만!
                </p>
              </div>
            </MainBanner>
            <MainBanner
              style={{
                background: `url(/images/main/main_banner_03.png) #FFFFFF no-repeat`,
                backgroundPosition: 'right 20px bottom 20px',
              }}
            >
              <div>
                <h4>거래처 관리</h4>
                <p>
                  하나 부터 열까지!
                  <br />
                  똑똑한 거래처 관리
                </p>
              </div>
            </MainBanner>
            <MainBanner
              style={{
                background: `url(/images/main/main_banner_04.png) #FFFFFF no-repeat`,
                backgroundPosition: 'right 20px bottom 20px',
              }}
            >
              <div>
                <h4>단가 관리</h4>
                <p>
                  이제는 어렵지 않아요!
                  <br />
                  거래처 별 단가 관리
                </p>
              </div>
            </MainBanner>
            <MainBanner
              style={{
                background: `url(/images/main/main_banner_05.png) #FFFFFF no-repeat`,
                backgroundPosition: 'right 20px bottom 20px',
              }}
            >
              <div>
                <h4>통계</h4>
                <p>
                  오늘은 어땠을까?
                  <br />한 눈에 보는 통계
                </p>
              </div>
            </MainBanner>
          </div>
        </StyleFlex>
      </BackgroundDiv2>
      <BottomBanner sx={{ marginBottom: '60px' }}>
        <Box>
          <h2>{t('지금 바로 레인드롭 시작하기!')}</h2>
          <h4 style={{ fontWeight: '300' }}>{t('스마트한 치과기공소 관리 레인드롭과 함께 시작하세요.')}</h4>
        </Box>
        <BannerButton href="/license">{t('시작하기')}</BannerButton>
      </BottomBanner>
    </>
  );
}
